import { defineChain } from 'viem';

export const chain138 = defineChain({
  id: 138,
  name: 'DeFi Oracle Meta Mainnet',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: {
      http: [
        (import.meta.env.VITE_RPC_URL_138 as string | undefined) || 'https://rpc.defi-oracle.io',
      ],
    },
  },
  blockExplorers: {
    default: { name: 'Blockscout', url: 'https://explorer.d-bis.org' },
  },
});
